<template>
    <div>
        <div v-if="isFinished && recommendedOffer" class="pb-4">
            <div class="text-center desktop:text-left
                    pt-7 desktop:pt-3
                    pb-2
                    flex
                    flex-col
                    justify-center"
                    :class="[
                        {'desktop:mb-8': recommendedOffer.banner},
                        theme !== 'themeAlt' ? 'px-5 text-white' : 'text-navy-dark'
                    ]">
                <div class="text-md font-light"
                        :class="theme !== 'themeAlt' ? 'text-white italic' : 'text-navy-dark'">
                    RESULTS
                </div>
                <h2 class="text-lg desktop:text-xl"
                    :class="theme !== 'themeAlt' ? 'text-white' : 'text-navy-dark'">
                    Offer Recommendation
                </h2>
            </div>
            <OfferCard :class="theme !== 'themeAlt' ? 'm-4' : ''"
                      :promo-link="promoLink"
                       v-bind="recommendedOffer"
                       :banner="null"
                       @select="selectOfferProxy(recommendedOffer)"/>
        </div>
        <Quiz v-else
              :theme="theme"
              :quiz="quiz"
              @finish-quiz="finishQuiz"/>
        <SlottedModal :is-immediately-visible="maintenancePopup"
                      modal-type="warning"
                      @dismiss="maintenancePopup = false">
            <template #contents>
                <div class="text-base
                            font-bold
                            mb-2">
                    <IconTriangleExclamation class="inline mr-1" /> Online ordering is currently under maintenance
                </div>
                <div>
                    Online ordering as well as account management features<br>on breezeline.com and in our My Breezeline mobile app<br>are currently unavailable due to scheduled maintenance.<br>We apologize for any inconvenience.
                </div>
            </template>
        </SlottedModal>
    </div>
</template>

<script>
    import Quiz from './Quiz.vue'
    import OfferCard from "../../molecules/OfferCard/index.vue";
    import { DateTime as dt } from 'luxon'
    import {mapActions, mapGetters, mapState,} from "vuex";
    import SlottedModal from "../SlottedModal/index.vue"
    import IconTriangleExclamation from "@/atoms/icons/IconTriangleExclamation"
    import products from "../../../templates/products/_products";
    import skuList from "../../../apps/Buyflow/sku.json";


    export default {
        name: 'HeroSpeedQuiz',
        components: {
            SlottedModal,
            OfferCard,
            Quiz,
            IconTriangleExclamation
        },
        props: {
            productMetadata: {
                type: String,
                required: false,
                default: "[]",
            },
            theme: {
                type: String,
                default: '',
            },
            experience: {
                type: String,
                default: '',
            },
            promoLink: {
                type: String,
                default: null,
            },
        },
        data () {
            return {
                quiz: [
                    {
                        heading: 'How does your household use the internet?',
                        subheading: '',
                        skipAnswer: 1,
                        gaEvents: null,
                        answers: [
                            {
                                heading: 'Light User',
                                headingAlt: 'Light User',
                                subheading: 'Email, web browsing',
                                subheadingAlt: 'Email, web browsing',
                                descriptor: '',
                                descriptorAlt: '',
                                image: '/temp/envelope.png',
                                imageAlt: '/temp/mail.png',
                            },
                            {
                                heading: 'Moderate User',
                                headingAlt: 'Moderate User',
                                subheading: 'Light + streaming video, video calling',
                                subheadingAlt: 'Light + streaming video, video calling',
                                descriptor: '',
                                descriptorAlt: '',
                                image: '/temp/brandPlaySymbol.png',
                                imageAlt: '/temp/play.png',
                            },
                            {
                                heading: 'Heavy User',
                                headingAlt: 'Heavy User',
                                subheading: 'Moderate + work/school from home or online gaming',
                                subheadingAlt: 'Moderate + work/school from home or online gaming',
                                descriptor: '',
                                descriptorAlt: '',
                                image: '/temp/brandController.png',
                                imageAlt: '/temp/controller.png',
                            },
                        ],
                    },
                    {
                        heading: 'How many people use the internet in your home?',
                        subheading: 'To help determine your bandwidth needs we first need to know how many people will be using the internet at the same time.',
                        skipAnswer: 2,
                        gaEvents: null,
                        answers: [
                            {
                                heading: '1',
                                headingAlt: '1',
                                subheading: 'lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
                                subheadingAlt: '',
                                descriptor: '',
                                descriptorAlt: '',
                                image: '/temp/placeholder.png',
                                imageAlt: '',
                            },
                            {
                                heading: '2',
                                headingAlt: '2',
                                subheading: 'lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
                                subheadingAlt: '',
                                descriptor: '',
                                descriptorAlt: '',
                                image: '/temp/placeholder.png',
                                imageAlt: '',
                            },
                            {
                                heading: '3',
                                headingAlt: '3',
                                subheading: 'lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
                                subheadingAlt: '',
                                descriptor: '',
                                descriptorAlt: '',
                                image: '/temp/placeholder.png',
                                imageAlt: '',
                            },
                            {
                                heading: '4+',
                                headingAlt: '4+',
                                subheading: 'lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
                                subheadingAlt: '',
                                descriptor: '',
                                descriptorAlt: '',
                                image: '/temp/placeholder.png',
                                imageAlt: '',
                            },
                        ],
                    },
                    {
                        heading: 'How big is your home?',
                        subheading: 'To determine your coverage needs we\'ll need to know the size of your home.',
                        skipAnswer: 1,
                        gaEvents:{
                            category: 'resi: calculator button',
                            action: 'resi: calculator see results button',
                            label: this.getSeeResultsGALabel()
                        },
                        answers: [
                            {
                                heading: 'Small',
                                headingAlt: '',
                                subheading: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
                                subheadingAlt: '',
                                descriptor: '(under 1,000 sq/ft)',
                                descriptorAlt: '<1,000sq ft',
                                image: '/temp/smallHome.png',
                                imageAlt: '/temp/smallHouse.png',
                            },
                            {
                                heading: 'Medium',
                                headingAlt: '',
                                subheading: 'lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
                                subheadingAlt: '',
                                descriptor: '(1,000 to 3,000 sq/ft)',
                                descriptorAlt: '1,000-3,000sq ft',
                                image: '/temp/mediumHome.png',
                                imageAlt: '/temp/mediumHouse.png',
                            },
                            {
                                heading: 'Large',
                                headingAlt: '',
                                subheading: 'lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
                                subheadingAlt: '',
                                descriptor: '(over 3,000 sq/ft)',
                                descriptorAlt: '3,000sq ft+',
                                image: '/temp/largeHome.png',
                                imageAlt: '/temp/largeHouse.png',
                            },
                        ],
                    },
                ],
                isFinished: false,
                recommendedOffer: null,
                maintenancePopup: false,
            }
        },
        computed: {
            ...mapState([
                'offers',
                'meta',
                'env',
            ]),
            ...mapGetters([
                'offers',
                'offersByType',
                'parseMetadata',
                'filterAndMerge',
            ]),
            productData () {
                return {
                    file: this.parseMetadata(products ?? []),
                    craft: this.parseMetadata(JSON.parse(this.productMetadata) ?? [])
                }
            },
            mergedMetadata() {
                return this.filterAndMerge({base: this.productData.file, override: this.productData.craft})
            },
            visibleOffers() {
                return this.offersByType({mergedMetadata: this.mergedMetadata, offerType: 'internet', customType: null})
            },
        },
        methods: {
            getSeeResultsGALabel(){
                return window.location.pathname === '/lets-get-started'? 'resi: calculator see results lets get started page': 'resi: calculator see results internet page'
            },
            getSelectPlanGALabel(){
                return window.location.pathname === '/lets-get-started'? 'resi: calculator select plan lets get started page': 'resi: calculator select plan internet page'
            },
            ...mapActions([
                'toggleCheckAvailabilityModal',
                'selectOffer',
                'setSelectedOffer',
                'setEcommerceItem'
            ]),
            finishQuiz (results) {
                const i  = this.visibleOffers
                const ie = this.offersByType({mergedMetadata: this.mergedMetadata, offerType: 'internet-equipment',customType: null})

                switch(results.join(' ')){
                    case '0 0 0':
                    case '0 1 0':
                        // 50mbps or first one
                        this.recommendedOffer = i[0]
                        break
                    case '0 2 0':
                    case '0 3 0':
                    case '1 0 0':
                    case '1 1 0':
                        // 100mbps
                        this.recommendedOffer = i[1]
                        break
                    case '1 2 0':
                    case '1 3 0':
                    case '2 0 0':
                    case '2 1 0':
                        // 400mbps
                        this.recommendedOffer = i[2]
                        break
                    case '2 2 0':
                    case '2 3 0':
                        // 1000mbps
                        this.recommendedOffer = i[i.length - 1]
                        break
                    case '0 0 1':
                    case '0 0 2':
                    case '0 1 1':
                    case '0 1 2':
                        // 50 plus equipment
                        this.recommendedOffer = ie[0]
                        break
                    case '0 2 1':
                    case '0 2 2':
                    case '0 3 1':
                    case '0 3 2':
                    case '1 0 1':
                    case '1 0 2':
                    case '1 1 1':
                    case '1 1 2':
                        // 100mbps plus equipment
                        this.recommendedOffer = ie[1]
                        break
                    case '1 2 1':
                    case '1 2 2':
                    case '1 3 1':
                    case '1 3 2':
                    case '2 0 1':
                    case '2 0 2':
                    case '2 1 1':
                    case '2 1 2':
                        // 400mbps plus equipment
                        this.recommendedOffer = ie[2]
                        break
                    case '2 2 1':
                    case '2 2 2':
                    case '2 3 1':
                    case '2 3 2':
                        // 1000mbps plus equipment
                        this.recommendedOffer = ie[ie.length - 1]
                        break
                    default:
                        // 400mbps plus equipment
                        this.recommendedOffer = ie[2]
                }
                if (this.recommendedOffer.banner){
                    this.recommendedOffer.banner.style = 'blue'
                }
                this.recommendedOffer = {
                    ...this.recommendedOffer,
                    gaCategory: 'resi: calculator button',
                    gaAction: `resi: calculator select plan ${this.recommendedOffer.title.toLowerCase()} button`,
                    gaLabel: this.getSelectPlanGALabel()
                }
                this.isFinished = true

                this.$store.dispatch('Personalization/ping', {
                    eventName: 'FILL_CALCULATOR',
                    payload: {
                        source: {
                            pageType: 'default',
                            url: window.location.href,
                            urlReferrer: document.referrer,
                            locale: 'en_US',
                        },
                        user: {
                            attributes: {
                                householdInternetUse: this.quiz[0].answers[results[0]].heading,
                                numberInternetUser: this.quiz[1].answers[results[1]].heading,
                                homeSize: this.quiz[2].answers[results[2]].heading,
                            },
                        },
                    },
                }, { root: true })
            },
            selectOfferProxy (offer) {
                if (this.env.buyflowMaintenance == true) {
                    if (this.env.buyflowMaintenanceTimeframe) {
                        let now = dt.now()
                        const timeframe = this.env.buyflowMaintenanceTimeframe.split(',').map(function (time) {
                            return dt.fromFormat(time, 'yyyy-MM-dd\'T\'HH:mm:ss')
                        })

                        if ((timeframe.length > 1 && timeframe[0].isBefore(now) && timeframe[1].isAfter(now)) || (timeframe.length === 1 && timeframe[0].isBefore(now))) {
                            this.maintenancePopup = true
                        } else {
                            this.continueSelectOffer(offer)
                        }
                    } else {
                        this.maintenancePopup = true
                    }
                } else {
                    this.continueSelectOffer(offer)
                }


            },
            continueSelectOffer(offer){
                // NOTE this emit is for storybook purposes only
                this.$emit('select-offer', { selectedOffer: offer })

                this.setSelectedOffer({ selectedOffer: offer })

                const items = [{
                    name: offer.name,
                    variant: offer.title,
                    list_name: offer.type + ' list',
                    brand: "Breezeline Online",
                    category: offer.type,
                    price: offer.promoPrice,
                    metric1: offer.fullPrice,
                    dimension1: offer.download,
                }]
                this.setEcommerceItem({item: items[0],})

                gtag("event", "view_item", {items,})
                gtag("event", "add_to_cart", {items,})
                if (offer?.sku) {
                    if (this.experience) {
                        this.$store.dispatch('Personalization/ping', {
                            eventName: 'ADD_TO_CART',
                            payload: {
                                source: {
                                    pageType: 'cart',
                                    url: window.location.href,
                                    urlReferrer: document.referrer,
                                    locale: 'en_US',
                                },
                                cart: {
                                    singleLine: {
                                        Product: {
                                            _id: skuList[offer.sku],
                                            price: offer.promoPrice?.toString(),
                                            quantity: '1',
                                        },
                                    },
                                },
                                campaignStats: [{
                                    experienceId: this.experience,
                                    stat: "Click",
                                    control: false,
                                    catalog: {
                                        Product: [this.recommendedOffer?.sku || ""]
                                    }
                                }]
                            },
                        })
                    } else {
                        this.$store.dispatch('Personalization/ping', {
                            eventName: 'ADD_TO_CART',
                            payload: {
                                source: {
                                    pageType: 'cart',
                                    url: window.location.href,
                                    urlReferrer: document.referrer,
                                    locale: 'en_US',
                                },
                                cart: {
                                    singleLine: {
                                        Product: {
                                            _id: skuList[offer.sku],
                                            price: offer.promoPrice?.toString(),
                                            quantity: '1',
                                        },
                                    },
                                },
                            },
                        })
                    }
                }

                if (this.meta.uuid && this.meta.conversationId && this.meta.isCurrentCustomer !== true){
                    this.selectOffer()
                } else {
                    this.toggleCheckAvailabilityModal({
                        visible: true,
                        routeToBuyflow: true,
                        resetSelectedOffer: false,
                        currentCustomerCheck: this.meta.isCurrentCustomer || false,
                    })
                }
            },
        }
    }
</script>
